import { useState, useEffect } from "react";
import PageHeader from "../../Layout/PageHeader";
import TabProgressBar from "../../Shared/Tab/TabProgressBar";
import { BasicInfo, ClientData, Mapping } from "./model/Client.type";
import ClientProductivity from "./ClientProductivity";
import ClientAccessorialCharges from "./ClientAccessorialCharges";
import ClientBasicInfo from "./ClientBasicInfo";
import ClientMapping from "./ClientMapping";
import ClientPackageType from "./ClientPackageType";
import ClientSetting from "./ClientSetting";
import { useParams } from "react-router-dom";
import { getClientDetails } from "./service/client.service";

export default function ClientAddEdit() {
  const { id } = useParams();
  const [clientData, setClientData] = useState<ClientData>({
    basicInfo: new BasicInfo(),
    mapping: new Mapping(),
  });
  const [clientCode, setClientCode] = useState<string>("");
  
  useEffect(() => {
    if (id) {
      getClientDetails(id).then((response) => {
        setClientCode(response.data?.code || "");
      });
    }
  }, [id]);

  const handelAllTabData = (data: ClientData) => {
    setClientData(data);
  };
  const [currentTab, setCurrentTab] = useState(0);
  const handleNext = () => {
    setCurrentTab((prevTab) =>
      Math.min(prevTab + 1, TabProgressBarData.length - 1)
    );
    const updatedCompletedTabs = [...completedTabs];
    updatedCompletedTabs[currentTab] = true;
    setCompletedTabs(updatedCompletedTabs);
  };
  const TabProgressBarData = [
    {
      step: 1,
      label: "Basic Information",
      content: (
        <ClientBasicInfo
          handelAllTabData={handelAllTabData}
          clientData={clientData}
          handleNext={handleNext}
        />
      ),
    },
    {
      step: 2,
      label: "Mapping",
      content: <ClientMapping handleNext={handleNext} />,
    },
    {
      step: 3,
      label: "Accessorial Charges",
      content: <ClientAccessorialCharges handleNext={handleNext} />,
    },
    {
      step: 4,
      label: "Package Type",
      content: <ClientPackageType handleNext={handleNext} />,
    },
    {
      step: 5,
      label: "Productivity",
      content: <ClientProductivity handleNext={handleNext} />,
    },
    {
      step: 6,
      label: "Setting",
      content: <ClientSetting />,
    },
  ];
  const [completedTabs, setCompletedTabs] = useState(
    Array(TabProgressBarData.length).fill(false)
  );
  return (
    <>
      <PageHeader
        addUrl="/account/client/overview/create"
        listUrl="/account/client/overview/list-view"
        gridUrl="/account/client/overview/grid-view"
        viewType={true}
      />
      <div className="clearfix"></div>
      <h5 className="text-start mt-1 mb-3">
      {id ? `Edit Client (${clientCode})` : "Create Client"}
      </h5>

      <TabProgressBar
        tabs={TabProgressBarData}
        handleNext={handleNext}
        currentTab={currentTab}
      />
    </>
  );
}
